import * as angular from 'angular';

import { StringReplacement, ComponentDefinition } from '../../models';

class RenameTableController implements angular.IComponentController {
    formCtrl: angular.IFormController;
    rows: StringReplacement[];

    static $inject = [];

    addRow() {
        this.rows.push({ newValue: '', oldValue: '' });
        this.formCtrl.$setDirty();
    }

    deleteRow(row: StringReplacement): void {
        this.rows.splice(this.rows.indexOf(row), 1);
        this.formCtrl.$setDirty();
    }
}

export const wtRenameTable: ComponentDefinition = {
    componentId: 'wtRenameTable',
    controller: RenameTableController,
    template: require('./renameTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        rows: '=',
        formCtrl: '=',
        name: '@'
    }
};
